import { render } from "./RacesListMenu.vue?vue&type=template&id=0ad5b2b4"
import script from "./RacesListMenu.vue?vue&type=script&lang=js"
export * from "./RacesListMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__